import { render } from "./DataScienceDetailsComponent.vue?vue&type=template&id=47b3462a&scoped=true"
import script from "./DataScienceDetailsComponent.vue?vue&type=script&lang=js"
export * from "./DataScienceDetailsComponent.vue?vue&type=script&lang=js"

import "./DataScienceDetailsComponent.vue?vue&type=style&index=0&id=47b3462a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b3462a"]])

export default __exports__